<span class="loading" *ngIf="loading">
    <i class="fa fa-spinner fa-spin" style="font-size:40px;color:white"></i>
</span>
<app-header [screentitle]='title'></app-header>
<app-side-menu-bar></app-side-menu-bar>
<div class="main-content">
    <!-- <div class="heading">
        <label class="heading-text">Delete History</label>
    </div> -->
    <div *ngIf="noRecordsShow" class="records">{{noRecords}}</div>
    <div class="example-container">
        <mat-paginator #paginator 
                [pageSize]="10"
                [pageSizeOptions]="[5, 10, 20,30]"
                showFirstLastButtons>
          </mat-paginator>
        <table mat-table [dataSource]="dataSource" [hidden]="noRecordsShow">

            <!-- File Name Column -->
            <ng-container matColumnDef="FileName">
                <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> File Name </th>
                <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.filenames}} </td>
            </ng-container>

            <!-- RecordCount Column -->
            <ng-container matColumnDef="RecordCount">
                <th class="rightHeaderCell" mat-header-cell *matHeaderCellDef> No. of Records Deleted </th>
                <td class="rightDataCell" mat-cell *matCellDef="let element">
                    <span>{{element.recordcount}}</span>
                </td>
            </ng-container>

            <!-- DeletedUser Column -->
            <ng-container matColumnDef="DeletedUser">
                <th class="rightHeaderCell" mat-header-cell *matHeaderCellDef> Deleted By </th>
                <td class="rightDataCell" mat-cell *matCellDef="let element"> {{element.deletedby}} </td>
            </ng-container>

            <!-- DeletedDate Column -->
            <ng-container matColumnDef="DeletedDate">
                <th class="rightHeaderCell" mat-header-cell *matHeaderCellDef> Deleted Date </th>
                <td class="rightDataCell" mat-cell *matCellDef="let element"> {{element.deleteddate}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="deleteHistoryColumn;sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: deleteHistoryColumn;"></tr>
        </table>
    </div>
</div>

<div class="alert alert-danger failMsg" *ngIf="showErrorMessage">
    {{errorMsg}}
</div>